// Shared helpers for the New Product Development (NPD) module, ported from the Sourcing Control Room prototype.

export const ST = ["In Progress", "Completed", "Under Review", "Delayed"];
export const SC = ["ip", "ok", "rv", "dl"];
export const STATUS_KEYS = ["IN_PROGRESS", "COMPLETED", "UNDER_REVIEW", "DELAYED"];
export const PAGE_SIZE = 15;

const DAY = 864e5;

export const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

// "2026-10-19" -> local Date at midnight
export const parseDate = (value) => {
  if (!value) return null;
  const [y, m, d] = String(value).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const fmt = (d) =>
  d ? d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "-";

export const iso = (d) =>
  d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");

export const addDays = (d, n) => new Date(d.getTime() + n * DAY);

// Joins API parts with their assembly line and converts dates and status for the views
export const enrichParts = (parts, lines) => {
  const byId = new Map(lines.map((l) => [l.id, l]));
  return parts
    .map((p) => ({
      ...p,
      L: byId.get(p.assemblyLineId),
      s: Math.max(0, STATUS_KEYS.indexOf(p.status)),
      cur: p.currentStage ?? 0,
      target: parseDate(p.targetDate),
      start: parseDate(p.startDate),
    }))
    .filter((p) => p.L);
};

export const late = (p, today) =>
  p.s === 1 || !p.target ? 0 : Math.max(0, Math.round((today - p.target) / DAY));

export const stg = (p) => (p.cur >= p.L.stages.length ? "All stages done" : p.L.stages[p.cur]);

export const countByStatus = (parts) => [0, 1, 2, 3].map((s) => parts.filter((p) => p.s === s).length);

// Most frequent key among the given items, as [key, count]
export const topBy = (items, keyFn) => {
  const m = {};
  items.forEach((x) => {
    const k = keyFn(x);
    m[k] = (m[k] || 0) + 1;
  });
  return Object.entries(m).sort((a, b) => b[1] - a[1])[0];
};

// Delayed first, then most days late
export const byUrgency = (today) => (a, b) => (b.s === 3) - (a.s === 3) || late(b, today) - late(a, today);
